
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Location } from '@angular/common';
import { decrypt } from './utilities/utilityFunctions';
import { SharedService } from './shared/sharedServices/shared.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    public myRoute: Router,
    private sharedServices: SharedService
  ) {}

  canActivate(): boolean {
    if ((localStorage.getItem('esp-profile-details'))) { 
    let d = JSON.parse(decrypt(localStorage.getItem('esp-profile-details')));  
    console.log(d.getSpRole,"d.getSpRole")    
     if(d.profileId){
      return true;
    }
    return false;
    } else {
      // localStorage.clear();
      localStorage.removeItem('esp-profile-details')
      localStorage.removeItem('login');
      localStorage.removeItem('ng2Idle.main.expiry');
      localStorage.removeItem('eduHistory');
      localStorage.removeItem('dob');
      localStorage.removeItem('loginDetails');
      localStorage.removeItem('addresses');
      localStorage.removeItem('primaryNationality');
      localStorage.removeItem('name');
      localStorage.removeItem('Avatar');
      localStorage.removeItem('isForeign');
      document.cookie = "profile=; _ga=0; path=/"
      this.myRoute.navigate(['auth/login'])
      return false;
    }
  }

}
